export default __webpack_public_path__ + "static/media/material.4b63fc5a.svg";